'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var ReactModal = require('react-modal');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var CloseIcon = require('../alloy-icon/CloseIcon.js');
var modal_module = require('./modal.module.scss.js');
var Modal_types = require('./Modal.types.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);
var ReactModal__default = /*#__PURE__*/_interopDefault(ReactModal);

var DEFAULT_MODAL_PORTAL = 'react-root-modals';
var Modal = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, close = _a.close, closeButtonLabel = _a.closeButtonLabel, contentClassName = _a.contentClassName, contentLabel = _a.contentLabel, focusSelector = _a.focusSelector, isOpen = _a.isOpen, _c = _a.portalTarget, portalTarget = _c === void 0 ? DEFAULT_MODAL_PORTAL : _c, _d = _a.style, style = _d === void 0 ? {} : _d, title = _a.title, _e = _a.transitionTimeMS, transitionTimeMS = _e === void 0 ? 500 : _e, _f = _a.variant, variant = _f === void 0 ? Modal_types.ModalVariant.standard : _f, props = tslib.__rest(_a, ["children", "className", "close", "closeButtonLabel", "contentClassName", "contentLabel", "focusSelector", "isOpen", "portalTarget", "style", "title", "transitionTimeMS", "variant"]);
    var parentSelector = function () {
        return document.getElementById(portalTarget);
    };
    // Use pointer cursor styling for non-required modals
    var cursor = close ? 'pointer' : 'initial';
    var resolvedStyles = tslib.__assign(tslib.__assign({}, style), { overlay: tslib.__assign({ cursor: cursor }, style === null || style === void 0 ? void 0 : style.overlay) });
    var handleAfterOpen = function (_a) {
        var _b;
        var contentEl = _a.contentEl;
        if (focusSelector) {
            var eleToFocus = contentEl.querySelector(focusSelector);
            (_b = eleToFocus === null || eleToFocus === void 0 ? void 0 : eleToFocus.focus) === null || _b === void 0 ? void 0 : _b.call(eleToFocus);
        }
    };
    return (jsxRuntime.jsx(ReactModal__default.default
    /**
     * TODO: Eventually remove ariaHideApp. See https://reactcommunity.org/react-modal/accessibility/#app-element.
     * Can we use Modal.setAppElement?? Or are there too many portals right now?
     */
    , tslib.__assign({ 
        /**
         * TODO: Eventually remove ariaHideApp. See https://reactcommunity.org/react-modal/accessibility/#app-element.
         * Can we use Modal.setAppElement?? Or are there too many portals right now?
         */
        ariaHideApp: false, className: cx__default.default(modal_module.default['cat-modal__wrapper'], (_b = {},
            _b["".concat(modal_module.default['cat-modal__wrapper--large'])] = variant === Modal_types.ModalVariant.large,
            _b), className), closeTimeoutMS: transitionTimeMS, contentLabel: contentLabel, isOpen: isOpen, onAfterOpen: handleAfterOpen, onRequestClose: close, parentSelector: parentSelector, shouldFocusAfterRender: !focusSelector, shouldReturnFocusAfterClose: true, style: resolvedStyles }, props, { children: jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default('d-flex', modal_module.default['min-vh-100--mobile']) }, { children: [jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('d-flex flex-column', modal_module.default['cat-modal__left-bar']) }, { children: close && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "ghost", "aria-label": closeButtonLabel, onClick: close, size: "small", className: "p-0" }, { children: jsxRuntime.jsx(CloseIcon.default, { className: modal_module.default['cat-modal__close-icon'], height: 30, width: 30 }) })), jsxRuntime.jsx("button", { "aria-hidden": "true", className: "d-lg-none flex-grow-1 m-0 p-0 bg-transparent border-0", onClick: close, tabIndex: -1 })] })) })), jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default(modal_module.default['cat-modal__content'], contentClassName) }, { children: [title && jsxRuntime.jsx("h2", tslib.__assign({ className: "h2 display-1 mb-4" }, { children: title })), children] }))] })) })));
};
var Modal$1 = Modal;

exports.DEFAULT_MODAL_PORTAL = DEFAULT_MODAL_PORTAL;
exports.default = Modal$1;
//# sourceMappingURL=Modal.js.map
